import { isObjectType } from 'graphql';
import unwrapFieldType from './unwrapFieldType.js';

const extractFieldStructure = (type, visitedTypes = new Set()) => {
  if (!isObjectType(type) || visitedTypes.has(type.name)) {
    return null;
  }

  visitedTypes.add(type.name);

  const fields = type.getFields();
  const fieldStructure = {};

  Object.keys(fields).forEach((fieldName) => {
    const field = fields[fieldName];
    const { isList, isRequired, type: fieldType } = unwrapFieldType(field.type);
    const isObject = isObjectType(fieldType);

    fieldStructure[fieldName] = {
      type: fieldType.name,
      isRequired,
      isList,
      description: field.description,
      isObject
    };

    if (isObject) {
      const nestedFields = extractFieldStructure(fieldType, visitedTypes);

      if (nestedFields) {
        fieldStructure[fieldName].fields = nestedFields;
      }
    }
  });

  return fieldStructure;
};

export default extractFieldStructure;
